module.exports = __webpack_public_path__ + "img/img-3-12.77487e64.png";